import React, { useEffect, useState } from 'react';
import {
  baseXUnit,
  color,
  fontSize,
  fontWeight,
  spacing,
  zIndex
} from '../../styles/theme';
import Button from '../elements/Button';
import HyperLink from '../elements/HyperLink';
import {
  COOKIE_CONSENT_KEY,
  initializeAnalytics
} from '../../analytics/analytics';

const CookieConsent: React.FunctionComponent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'all');
    setIsVisible(false);
    initializeAnalytics();
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'necessary');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-modal">
        <div className="content">
          <h3>Tietoa evästeistä</h3>
          <p>
            Käytämme evästeitä ja henkilötietoja parantaaksemme
            käyttäjäkokemusta, analysoidaksemme sivustomme käyttöä ja
            personoidaksemme mainoksia. Kolmannet osapuolet, kuten Google,
            voivat hyödyntää henkilötietoja samoihin tarkoituksiin.
          </p>
          <p>
            Voit hyväksyä kaikki evästeet, hylätä ei-välttämättömät evästeet tai
            säätää asetuksia tarpeidesi mukaan.
          </p>
          <div className="link-container">
            <HyperLink
              href="https://www.imt.fi/rekisteri-ja-tietosuojaseloste/"
              target="_blank"
              linkColor="purple-light"
            >
              Tietoa evästeistä
            </HyperLink>
          </div>
        </div>
        <div className="actions">
          <Button onClick={handleAcceptNecessary} className="secondary-button">
            Vain välttämättömät
          </Button>
          <Button onClick={handleAcceptAll} className="primary-button">
            Hyväksy kaikki
          </Button>
        </div>
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .cookie-consent-overlay {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: ${zIndex.modal + 1};
          display: flex;
          justify-content: center;
          padding: ${spacing.two};
          pointer-events: none;
        }
        .cookie-consent-modal {
          pointer-events: auto;
          background: ${color.white};
          box-shadow: 0 0 ${baseXUnit(4)} rgba(0, 0, 0, 0.15);
          border-radius: ${baseXUnit(2)};
          max-width: 600px;
          width: 100%;
          padding: ${spacing.three};
          display: flex;
          flex-direction: column;
          gap: ${spacing.two};
        }
        h3 {
          margin: 0 0 ${spacing.one};
          font-size: ${fontSize.px20};
          font-weight: ${fontWeight.bold};
          color: ${color.brand};
        }
        p {
          margin: 0 0 ${spacing.one};
          font-size: ${fontSize.px14};
          line-height: 1.5;
          color: ${color.dark};
        }
        .link-container {
          margin-top: ${spacing.half};
        }
        .actions {
          display: flex;
          gap: ${spacing.one};
          justify-content: flex-end;
          flex-wrap: wrap;
        }
        :global(.secondary-button) {
          background: ${color.lightGray} !important;
          color: ${color.dark} !important;
          box-shadow: none !important;
        }
        :global(.secondary-button:hover) {
          background: ${color.gray} !important;
          color: ${color.white} !important;
        }
        :global(.primary-button) {
          background: ${color.mintGreen} !important;
          color: ${color.dark} !important;
          box-shadow: 0 ${baseXUnit(0.2)} ${baseXUnit(2)} 0
            rgba(195, 235, 214, 0.4) !important;
        }
        :global(.primary-button:hover) {
          background: ${color.brand} !important;
          color: ${color.white} !important;
        }
        @media screen and (max-width: 600px) {
          .cookie-consent-overlay {
            padding: ${spacing.one};
          }
          .actions {
            flex-direction: column;
          }
          .actions > :global(.button) {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
